import { render, staticRenderFns } from "./ProductFeatureForm.vue?vue&type=template&id=022803c6&"
import script from "./ProductFeatureForm.vue?vue&type=script&lang=js&"
export * from "./ProductFeatureForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports